import React, { forwardRef, useRef, useContext } from "react";
import KeyValueDisplay from "../components/KeyVakueDisplay";
import { dateTimeFormatted } from "../../main";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { useEventContext } from "../../contexts/EventContextProvider";
import { PlaceholderContext } from "../../contexts/Contexts";
import { ErrorDialog } from "../modal/Dialog";


const DiscountCouponDisplayBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();
    const placeholder = useContext(PlaceholderContext);

    //console.log('DiscountCouponDisplayBar.p', p)

    const render = (p) => {
        return (
            <div className="flex-row" ref={r}>
                <div className="col-24">
                    <div className="ListItemDetails">
                        <div className="flex-column">
                            <div className="flex-row">
                                <input type="hidden" name="id" value={p.id || ''} />
                                <div className="col-6">
                                    <KeyValueDisplay label='active' value={p.active ? 'true' : 'false'} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='name' value={p.name} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='code' value={p.code} />

                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='created on' value={dateTimeFormatted(p.createdAt || '')} />
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-6">
                                    <KeyValueDisplay label='minimum order value' value={p.minimumOrderValue} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='percentage' value={`${p.percentage || 0}%`} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='amount' value={p.amount || 0} />

                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='expires on' value={dateTimeFormatted(p.expiryDate || '')} />
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-6">
                                    <KeyValueDisplay label='usage cap per user' value={p.usageCapPerUser || 0} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='usage cap' value={p.usageCap || 0} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='combinable' value={p.combinable ? 'true' : 'false'} />
                                </div>
                                <div className="col-6">
                                    <KeyValueDisplay label='updated on' value={dateTimeFormatted(p.updatedAt || '')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const renderCase = (state) => {
        switch (true) {
            case state?.state == 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case state?.data?.id > 0 && state.visibility:
                return render(state.data);
            case state?.state == 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    return (state?.discounts && state.discounts[p.id]) ? renderCase(state.discounts[p.id]) : <></>;
});

export default DiscountCouponDisplayBar;